import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Form } from 'react-bootstrap';
import WizardInput from './WizardInput';
//import FalconDropzone from 'components/common/FalconDropzone';
//import avatarImg from 'assets/img/team/avatar.png';
//import { isIterableArray } from 'helpers/utils';
import { contextCompany } from 'context';
import Flex from 'components/common/Flex';
import Input from 'components/common/Input';
import Avatar from 'components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
//import useCompany from 'hooks/useCompany';
import IconAlert from 'components/common/IconAlert';

const FormControl = ({ propInput }) => <Form.Control type="hidden" {...propInput} />;

const CompanyForm = ({ register, errors, setValue, watch, consultCompany }) => {
 const { user, nit, setNit } = contextCompany();
 const [avatar, setAvatar] = useState([]);

 return (
  <>
   {errors.avatr && (
    <IconAlert variant="warning" dismissible>
     <p className="mb-0">{errors.avatr.message}</p>
    </IconAlert>
   )}
   <Flex className="g-3 gy-md-0 h-100 gap-3 align-items-center justify-content-between mb-3" alignItems="center" wrap="wrap">
    <Avatar
     uploader
     size="4xl"
     src={avatar}
     mediaClass="img-thumbnail shadow-sm"
     propUploader={{
      multiple: false,
      classInput: 'logo',
      //register: register('avatar', { required: 'Logo requerido' }),
      onChange: img => setAvatar(img)
     }}
    />

    {nit ? (
     <Form.Group className="flex-fill">
      <Form.Label>Nit</Form.Label>
      <div className="position-relative">
       <Form.Control
        type="text"
        name="nit"
        placeholder="Nit de la empresa"
        className="pe-4 input-spin-none"
        isInvalid={errors['nit']}
        isValid={Object.keys(errors).length > 0 && !errors['nit']}
        autoComplete="off"
        {...register('nit', {
         required: 'Debe especificar un nit',
         pattern: {
          value: /[0-9]/i,
          message: 'Debe ingresar solo numeros'
         }
        })}
       />
       <div className="position-absolute end-0 top-50 translate-middle">
        <Button
         variant="link"
         type="button"
         size="sm"
         onClick={() => {
          if (user?.nit === watch('nit')) setNit(false);
          else if (watch('nit')) consultCompany(watch('nit'));
         }}
         className="d-flex align-items-center fs-0 text-700 p-0 me-3"
        >
         <FontAwesomeIcon icon={user?.nit === watch('nit') ? 'times' : 'arrow-right'} />
        </Button>
       </div>
      </div>
      <Form.Control.Feedback type="invalid">{errors['nit']?.message}</Form.Control.Feedback>
     </Form.Group>
    ) : (
     <Input
      label={
       <Flex justifyContent="between" className="">
        <div>Empresa*</div>
        <SoftBadge bg="primary" className="my-auto me-2 position-relative">
         Nit: {user?.nit}----
         <Button
          variant="falcon-primary"
          type="button"
          size="sm"
          onClick={() => setNit(true)}
          className="icon-item icon-item-sm rounded-circle position-absolute start-100 top-0 translate-middle"
         >
          <FontAwesomeIcon icon="pencil-alt" />
         </Button>
        </SoftBadge>
       </Flex>
      }
      type="text"
      name="name"
      errors={errors}
      placeholder="Nombre de la empresa"
      formLabelProps={{ className: 'w-100' }}
      formGroupProps={{ className: 'flex-fill' }}
      formControlProps={{
       readOnly: !!user?.name,
       className: 'input-spin-none',
       defaultValue: user?.name,
       autoComplete: 'off',
       ...register('name', {
        required: 'Debe especificar el nombre de empresa',
        validate: value => !/[^a-zA-Z0-9._-ñ Ñ]/g.test(value) || 'El nombre debe tener caracteres validos',
        minLength: {
         value: 5,
         message: 'El nombre debe tener al menos 5 caracteres'
        }
       })
      }}
     />
    )}
   </Flex>

   <Row className="g-2 mb-3">
    <Input
     type="select"
     label="Modelo"
     name="gender"
     errors={errors}
     formGroupProps={{ as: Col, sm: 6 }}
     options={[
      { label: 'INMOBILIARIA', value: 'INMOBILIARIA' },
      { label: 'TRANSPORTES', value: 'TRANSPORTES' },
      { label: 'TIENDAS', value: 'TIENDAS' }
     ]}
     formControlProps={{
      ...register('gender')
     }}
    />

    <Input
     label="Movil"
     type="tel"
     name="phone"
     errors={errors}
     placeholder="Numero cel"
     formGroupProps={{ as: Col, sm: 6 }}
     formControlProps={{
      type: 'tel',
      autoComplete: 'tel',
      value: watch('phone'),
      onChange: e => setValue('phone', e)
      //countryCallingCodeEditable={true}
      //defaultCountry="CO"
     }}
    />
    <FormControl
     propInput={{
      ...register('phone', {
       required: 'Movil requerido',
       minLength: { value: 10, message: 'Movil invalido' },
       pattern: { value: /[+0-9]/i, message: 'Solo numeros' }
      })
     }}
    />
   </Row>

   <Input
    type="email"
    label="Mail"
    name="mail"
    errors={errors}
    placeholder="Email"
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{
     className: 'input-spin-none',
     ...register('mail', {
      required: 'Debe especificar el email de la empresa',
      pattern: {
       value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
       message: 'Email invalido'
      }
     })
    }}
   />

   <WizardInput
    type="text"
    label="Address"
    name="address"
    errors={errors}
    formGroupProps={{ className: 'mb-3' }}
    formControlProps={{
     ...register('address', {
      required: 'La direccion de la empresa es requerida'
     })
    }}
   />
  </>
 );
};

FormControl.propTypes = { propInput: PropTypes.object.isRequired };

CompanyForm.propTypes = {
 register: PropTypes.func.isRequired,
 errors: PropTypes.object,
 setValue: PropTypes.func.isRequired,
 watch: PropTypes.func,
 consultCompany: PropTypes.func
};

export default CompanyForm;
